import type { MetaIcon } from "../constants/icon.constant";

export interface SolidIconProps {
  icon: MetaIcon;
  color: string;
}

export default function SolidIconBuilder(props: Readonly<SolidIconProps>) {
  return (
    <svg
      width={props.icon.width}
      height={props.icon.height}
      viewBox={props.icon.viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d={props.icon.path} fill={props.color} />
    </svg>
  );
}
